package co.maytes.standupbot.dashboard.components.widgets

import androidx.compose.runtime.Composable
import co.maytes.standupbot.dashboard.styles.Palette
import co.maytes.standupbot.dashboard.styles.Spacing
import co.maytes.standupbot.dashboard.styles.Typography
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.classNames
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.text.SpanText
import org.jetbrains.compose.web.dom.A
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.Nav
import org.jetbrains.compose.web.dom.Span
import org.jetbrains.compose.web.dom.Text

data class TocItem(val anchor: String, val label: String)

@Composable
fun TocSidebar(
    heading: String = "On this page",
    items: List<TocItem>,
    modifier: Modifier = Modifier,
    quiet: Boolean = false,
) {
    val rail = if (quiet) Modifier.classNames("sb-toc", "mk-toc") else Modifier.classNames("sb-toc")
    Nav(attrs = rail.then(modifier).toAttrs()) {
        if (quiet) {
            SpanText(text = heading, modifier = Modifier.classNames("mk-toc-heading"))
        } else {
            SpanText(
                text = heading.uppercase(),
                modifier = Modifier
                    .classNames("sb-tracker")
                    .margin(bottom = Spacing.xs)
                    .styleModifier { property("padding-left", "10px") },
            )
        }
        items.forEachIndexed { idx, item ->
            val number = (idx + 1).toString().padStart(2, '0')
            A(href = "#${item.anchor}") {
                Div {
                    if (quiet) {
                        Span(attrs = { classes("mk-toc-num") }) { Text(number) }
                    } else {
                        SpanText(
                            text = "$number  ",
                            modifier = Modifier
                                .fontSize(Typography.caption.size)
                                .fontWeight(500)
                                .color(Palette.textTertiary)
                                .styleModifier { property("font-family", Typography.FONT_MONO) },
                        )
                    }
                    Text(item.label)
                }
            }
        }
    }
}
